export default __webpack_public_path__ + "static/media/TITUS-Cyberbit-Basic-Regular.0c5120f6.ttf";